<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="forTbFilter" @submit.native.prevent>
            <el-form-item label="套餐组名：">
                <el-select v-model="searchForm.pkgGroupId" filterable clearable>
                    <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套餐类型：">
                <el-select v-model="searchForm.packageTypeCode" clearable>
                    <el-option v-for="item in pkgTypeOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态：">
                <el-select v-model="searchForm.state" clearable>
                    <el-option v-for="item in pkgStateOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套餐名称：">
                <el-input v-model.trim="searchForm.packageName" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getAgentPkgListPageHandle">搜索查询</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >
            <el-table-column prop="packageId" label="套餐编码"></el-table-column>
            <el-table-column prop="pkgGroupName" label="套餐组名"></el-table-column>
            <el-table-column prop="packageName" label="套餐名称"></el-table-column>
            <el-table-column prop="packageTypeName" label="套餐类型"></el-table-column>
            <el-table-column prop="verifyPriceRmb" label="套餐成本价（元）"></el-table-column>
            <el-table-column prop="salePriceRmb" label="套餐售价（元）"></el-table-column>
            <!-- <el-table-column prop="isNextMonthName" label="跨月类型"></el-table-column> -->
            <el-table-column label="排序">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.sort" maxlength="8" @change="updateSortNo(scope.row)" clearable></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="supplierTypeName" label="所属类别"></el-table-column>
            <el-table-column prop="stateName" label="状态"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="showAgentEditPkg(scope.row)">编辑</el-button>
                    <el-button type="text" size="small" @click="changeAgentPkgStateHandle(scope.row.id)">{{ showbtnText(scope.row.state) }}</el-button>
                </template>                  
            </el-table-column>
        </el-table>             
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  
        <el-dialog :append-to-body="true"  title="套餐编辑" :visible.sync="agentEditPkgVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="agentEditPkgForm" :model="agentEditPkgForm" :rules="agentEditPkgRules" label-width="120px">
                <el-form-item label="套餐名称：">
                    <span>{{ agentEditPkgForm.packageName }}</span>
                </el-form-item>
                <el-form-item label="套餐成本价：">
                    <span>{{ agentEditPkgForm.verifyPriceRmb }} 元</span>
                </el-form-item>
                <el-form-item label="套餐售价：" prop="salePriceRmb">
                    <el-row>
                        <el-col :span="22">
                            <el-input type="number" v-model.number.trim="agentEditPkgForm.salePriceRmb"></el-input> 
                        </el-col>
                        <el-col :span="2" class="center">元</el-col>
                    </el-row>
                                    
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="agentEidtPkgHandle">确 定</el-button>
            </div>            
        </el-dialog>           
    </div>
</template>
<script>
import {getAgentPkgListPage, updateAgentPkg, changeAgentPkgState, agentPkgSort} from '@/api/package.js'
import common from '@/utils/common.js'
export default {
    data(){
        var checkSalePrice = (rule, value, callback) => {
            if(value < this.agentEditPkgForm.verifyPriceRmb){
                return callback(new Error('套餐售价不得低于套餐成本价'))
            }
            callback();
        }
        return {
            pkgGroup: [],
            searchForm: {
                pkgGroupId: '',
                packageTypeCode: '',
                state: '',
                packageName: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0,
            },
            agentEditPkgForm: {
                packageName: '',
                supplierTypeName: '',
                verifyPriceRmb: '',
                salePriceRmb: ''
            },
            agentEditPkgVisibale: false,
            pkgTypeOption: [],
            pkgStateOption: [],            
            currentId: '',            
            agentEditPkgRules: {
                salePriceRmb: [
                    {required: true, message: '请输入套餐售价', trigger: 'blur'},
                    {validator: this.checkFloat, trigger: 'blur'},
                    {validator: checkSalePrice, trigger: 'blur'}
                ]
            }
        }
    },
    methods: {
        cancel(){
            this.agentEditPkgVisibale = false;
            this.$refs.agentEditPkgForm.resetFields();
        },
        showbtnText(state){
            return common.showTxtByState(state, {0: '上架', 1: '下架'})
        },         
        showAgentEditPkg(row){
            this.agentEditPkgVisibale = true;
            for(var key in this.agentEditPkgForm){
                this.agentEditPkgForm[key] = row[key];
            }
            this.currentId = row.id;
        },
        agentEidtPkgHandle(){
            var data = {
                id: this.currentId,
                salePriceRmb: this.agentEditPkgForm.salePriceRmb
            }
            this.$refs.agentEditPkgForm.validate(valid => {
                if(valid){
                    updateAgentPkg(data).then(res => {
                        if(res.data.code == 200){                    
                            this.$message.success(res.data.message);
                            this.getAgentPkgListPageHandle();
                            this.agentEditPkgVisibale = false;
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }
            })
        },
        getAgentPkgListPageHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            common.getAgentPkgGroupListCom(this, 'pkgGroup');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);            
            getAgentPkgListPage(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        changeAgentPkgStateHandle(id){
            var data = {
                id
            }
            changeAgentPkgState(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    this.getAgentPkgListPageHandle();
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        updateSortNo(row){
            //修改排序号
            var data = {
                id: row.id,
                sort: row.sort
            }
            agentPkgSort(data).then(res => {
                if(res.data.code == 200){
                    this.getAgentPkgListPageHandle();
                }
            })            
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAgentPkgListPageHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getAgentPkgListPageHandle();
        }          
    },
    created(){
        this.getAgentPkgListPageHandle();
        common.getPkgTypeOptionCom(this, 'pkgTypeOption');
        common.getPkgStateOptionCom(this, 'pkgStateOption');
    }
}
</script>
<style lang="less" scoped>

</style>

